// extracted by mini-css-extract-plugin
export var active = "_sv-1";
export var circle = "_sv-0";
export var completed = "_sv-2";
export var connector = "_sv-4";
export var connectorCompleted = "_sv-7";
export var connectorSpacer = "_sv-5";
export var iconStrokeOverride = "_sv-8";
export var labelContainer = "_sv-6";
export var pending = "_sv-3";